export enum Role {
  ADMINISTRATOR='administrator',
  INSTRUCTOR='instructor'
}

export interface RoleEntity {
  id: string;
  updatedAt: number;
  userId: string;
  orgId: string;
  roleType: string;
  role: string;
  beginDate: number;
}

export interface User {
  id: string;
  updatedAt: number;
  userMasterIdentifier: string;
  username: string;
  enabledUser: 1 | 0;
  givenName: string;
  familyName: string;
  primaryOrgId: string;
  identifier: string;
  email: string;
  phone: string;
  roles: RoleEntity[];
}
